import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeepItPanelsService } from '../keep-it-panels.service';
import { RegsFollowService } from '../../data/regs-follow.service';
import { KeepItSheetComponent } from '../keep-it-sheet/keep-it-sheet.component';
import { KeepItPopoutComponent } from '../keep-it-popout/keep-it-popout.component';
import { ChangeEvent, Waters } from '../../domain/regs-models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-keep-it-host',
  standalone: true,
  imports: [CommonModule, KeepItSheetComponent, KeepItPopoutComponent],
  template: `
    <!-- Main Can I Keep It Bottom Sheet Container -->
    <app-keep-it-sheet
      *ngIf="panels.isOpen()"
      [initialSpeciesId]="panels.speciesId()"
      [initialSector]="panels.sector()"
      [initialWaters]="panels.waters()"
      [initialFollowing]="panels.showFollowing()"
      (close)="panels.close()"
    ></app-keep-it-sheet>

    <!-- Skipper Popout Banner on followed rules change -->
    <app-keep-it-popout
      *ngIf="activePopoutEvent && !panels.isOpen()"
      [event]="activePopoutEvent"
      (details)="onPopoutDetails(activePopoutEvent)"
      (dismiss)="onPopoutDismiss()"
    ></app-keep-it-popout>
  `,
})
export class KeepItHostComponent implements OnInit, OnDestroy {
  panels = inject(KeepItPanelsService);
  follows = inject(RegsFollowService);

  private subs = new Subscription();

  ngOnInit(): void {
    // Check for follow changes on launch
    this.follows.check();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  get activePopoutEvent(): ChangeEvent | null {
    return this.follows.pending.length > 0 ? this.follows.pending[0] : null;
  }

  onPopoutDetails(e: ChangeEvent): void {
    this.follows.dismissAll();
    const waters = e.jurisdictions.length === 1 ? Waters.of(e.jurisdictions[0]) : undefined;
    this.panels.open({
      sector: e.sector,
      waters,
      showFollowing: true,
    });
  }

  onPopoutDismiss(): void {
    this.follows.dismissAll();
  }
}
